var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import { AppAside, AppBreadcrumb, AppFooter, AppHeader, AppSidebar, AppSidebarFooter, AppSidebarForm, AppSidebarHeader, AppSidebarMinimizer, AppSidebarNav } from '@coreui/react';
// sidebar nav config
// import navigation from '../../_nav';
// routes config
// import routes from '../../routes';
import RXASide from './RXASide';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { createStore } from 'redux';

import { Actions, States } from './RXLayoutActions';

// const Actions = {
//   INIT: 0,
//   LOAD_COMPONENT: 1,
//   UNLOAD_COMPONENT: 2
// };

// const States = {
//   UNDEFINED: -1,
//   INITIALIZED: 0,
//   COMPONENT_LOADED: 1,
//   COMPONENT_UNLOADED: 2
// };

var logdown = require('logdown');
var console = logdown('rx-dashboard-default-layout', { prefixColor: '#00bcd4' });

var Reducer = function Reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {

    case Actions.INIT:
      return { state: States.INITIALIZED };

    case Actions.LOAD_COMPONENT:
      console.log('in update_location actions');

      return { state: States.COMPONENT_LOADED, component: action.component };

    case Actions.UNLOAD_COMPONENT:
      return { state: States.COMPONENT_UNLOADED };

    default:
      return { state: States.UNDEFINED };

  }
};

var DefaultLayout = function (_Component) {
  _inherits(DefaultLayout, _Component);

  function DefaultLayout(props) {
    _classCallCheck(this, DefaultLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.actionStore = createStore(Reducer);
    console.log('NEW defaultLayout log props: ' + Object.keys(props));
    console.log('component: ' + props.component);
    console.log('dashboardConfiguration: ' + props.dashboardConfiguration);
    _this.state = {
      navigation: { items: _this.props.dashboardConfiguration.navigation }

      //RETRIEVE AND BUILD ROUTES FROM CONF
      // this.routes = routes(this.props.dashboardConfiguration)
    };_this.routes = _this.props.routes;
    return _this;
  }

  DefaultLayout.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        component = _props.component,
        props = _objectWithoutProperties(_props, ['component']);

    return React.createElement(
      'div',
      { className: 'app' },
      React.createElement(
        AppHeader,
        { fixed: true },
        React.createElement(DefaultHeader, { logo: this.props.logo, logoMinimized: this.props.logoMinimized, loginManager: this.props.loginManager })
      ),
      React.createElement(
        'div',
        { className: 'app-body' },
        React.createElement(
          AppSidebar,
          { fixed: true, display: 'lg' },
          React.createElement(AppSidebarHeader, null),
          React.createElement(AppSidebarForm, null),
          React.createElement(AppSidebarNav, _extends({ navConfig: this.state.navigation }, props)),
          React.createElement(AppSidebarFooter, null),
          React.createElement(AppSidebarMinimizer, null)
        ),
        React.createElement(
          'main',
          { className: 'main' },
          React.createElement(AppBreadcrumb, { appRoutes: this.routes }),
          React.createElement(
            Container,
            { fluid: true },
            React.createElement(
              Switch,
              null,
              this.props.routes.map(function (route, idx) {
                return route.component ? React.createElement(Route, { key: idx, path: route.path, exact: route.exact, name: route.name, render: function render(props) {
                    return React.createElement(route.component, _extends({}, props, { actionStore: _this2.actionStore, actions: Actions, managers: _this2.props.managers }));
                  } }) : null;
              }),
              React.createElement(Redirect, { from: '/', to: this.props.defaultRoute })
            )
          )
        ),
        React.createElement(
          AppAside,
          { fixed: true },
          React.createElement(RXASide, { actionStore: this.actionStore, states: States })
        )
      )
    );
  };

  return DefaultLayout;
}(Component);

DefaultLayout.defaultProps = {
  logo: null,
  logoMinimized: null
};

export default DefaultLayout;